import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/UserAccounts'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class UserAccountsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "UserAccountsStore",
			variables: false,
		})
	}
}

export async function load_UserAccounts(params) {
  await initClient()

	const store = new UserAccountsStore()

	await store.fetch(params)

	return {
		UserAccounts: store,
	}
}
